import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { ImageType, type LibItemSysIcon } from '@types';
import Image from '@components/Image';
import { $libSelected } from '../stores/libSelected';
import onItemClick from '../actions/onItemClick';

type Props = {
  index: number;
  data: LibItemSysIcon;
};

export function IconItem({ data, index }: Props) {
  const active = useStore($libSelected).includes(index);
  const { url, frame } = data;
  const [count, setCount] = useState(0);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (frame > 1) {
      timer.current = setInterval(() => {
        setCount((prev) => (prev + 1 >= frame ? 0 : prev + 1));
      }, 80);
    }
    return () => {
      clearInterval(timer.current!);
    };
  }, []);

  return (
    <div
      className={classNames(
        'relative mx-5 mb-15 flex h-80 w-80 cursor-pointer items-center justify-center rounded bg-black-gray',
        { 'ring-2 ring-inset ring-orange': active }
      )}
      onClick={() => onItemClick(index)}
    >
      <div className="relative h-50 w-50 overflow-hidden">
        <Image
          type={ImageType.sysMedia}
          src={url}
          style={{
            transform: `translate3d(0, -${50 * count}px, 0)`,
          }}
        />
      </div>
      {frame > 1 && (
        <Image
          src="/imgs/gif-marker.f465f1f6745579e7a00d9798140c9462.png"
          type={ImageType.sysMedia}
          className="absolute right-3 bottom-3 h-16 w-16"
        />
      )}
    </div>
  );
}
